import { render, staticRenderFns } from "./Typerighter.vue?vue&type=template&id=c9192fc8&scoped=true&"
import script from "./Typerighter.vue?vue&type=script&lang=js&"
export * from "./Typerighter.vue?vue&type=script&lang=js&"
import style0 from "./Typerighter.vue?vue&type=style&index=0&id=c9192fc8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9192fc8",
  null
  
)

export default component.exports